import styled from "styled-components";

const SectionTitleSpan = styled.span`
  display: block;
  font-size: 17px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;

  @media (max-width: 575px) {
    font-size: 13px;
  }
`;
export default SectionTitleSpan;
